import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/sipl-content";

export default function WhatsAppFAB() {
  const text = encodeURIComponent(
    "Hello SIPL team, I'd like to discuss a project enquiry."
  );
  return (
    <a
      href={`https://wa.me/${COMPANY.phoneRaw}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 group"
    >
      <span className="absolute right-16 top-1/2 -translate-y-1/2 hidden md:block bg-white text-sipl-primary text-xs font-medium px-3 py-1.5 rounded-md shadow-md border border-sipl-line opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
        Chat with SIPL
      </span>
      <span className="relative flex">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <span className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] flex items-center justify-center transition">
          <MessageCircle className="w-7 h-7" />
        </span>
      </span>
    </a>
  );
}
